/**
 * @file
 *
 * @fileoverview Will display messages for the login page when the user is redirected
 * from other pages.
 */

import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMessages } from '~/jobiqo/hooks/messages';

export function useLoginMessages() {
  const intl = useIntl();
  const router = useRouter();
  const messagesService = useMessages();
  // Check if the login comes with some redirect info.
  useEffect(() => {
    if (messagesService.messages.length === 0) {
      switch (router?.query?.destination) {
        case 'checkout':
          return messagesService.addMessage({
            type: 'success',
            text: intl.formatMessage({
              id: 'user_login_destination_checkout',
              defaultMessage: 'You have to login to access the checkout page',
            }),
          });
        default:
          return;
      }
    }
  }, []);

  return {};
}
